const DASHBOARD_BASE_ENDPOINT = '/dashboard';

export const DashboardRoutes = {
  stats: () => `${DASHBOARD_BASE_ENDPOINT}/stats`,
  insights: () => `${DASHBOARD_BASE_ENDPOINT}/insights`,
  details: (id: string) => `${DASHBOARD_BASE_ENDPOINT}/report?id=${id}`,
  availableDates: (envGuid: string) => `${DASHBOARD_BASE_ENDPOINT}/available-dates/${envGuid}`,
};
